import { ColumnDef } from '@if/mui'
import { InteracWire } from '@src/types/interac'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

/** `DateTime.MinValue` as the monolith serializes it — a transfer with no reception date. */
const NO_RECEIVED_ON = '0001-01-01T00:00:00'

export const useDeletedInteracWireColumns = (): ColumnDef<InteracWire>[] => {
  const { t } = useTranslation()

  return useMemo<ColumnDef<InteracWire>[]>(
    () => [
      {
        name: 'receivedOn',
        type: 'dateonly',
        header: t('common.date'),
        getValue: (row) => (row.receivedOn === NO_RECEIVED_ON ? null : row.receivedOn),
        minWidth: 130,
      },
      {
        name: 'amount',
        type: 'currencydecimal',
        header: t('interacWire.amount'),
        width: 130,
      },
      {
        name: 'sentBy',
        type: 'titleSubtitle',
        header: t('interacWire.from'),
        subtitle: 'senderEmail',
        minWidth: 220,
        flexGrow: 1,
      },
      {
        name: 'message',
        header: t('interacWire.message'),
        minWidth: 200,
        flexGrow: 1,
      },
      {
        name: 'discardedBy',
        header: t('interacHistory.discardedBy'),
        minWidth: 150,
      },
      {
        name: 'discardedOn',
        type: 'dateonly',
        header: t('interacHistory.discardedOn'),
        minWidth: 130,
      },
      {
        name: 'discardReason',
        header: t('interacHistory.discardReason'),
        minWidth: 200,
        flexGrow: 1,
      },
    ],
    [t],
  )
}
